/* eslint-disable react/no-array-index-key */
import '@fontsource/poppins';
import { Icon } from '@iconify/react';
import axios from 'axios';
import dayjs from 'dayjs';

import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}/v2/admin/jobs/group/past-direct-listing/create`;

export default function CreateNewSlotNurse() {
  const { id } = useParams();
  const navigate = useNavigate();
  const state = useLocation();
  const { auth } = useAuth();
  const [open, setOpen] = useState(false);
  const handleBack = () => {
    navigate(state?.prevLocation || -1);
  };

  const [createSlot, setCreateSlot] = React.useState({
    clinicId: '',
    shared_to: '',
    sharedTo: '',
    profession: '',
    price: '',
    scope: '',
    job_desc: '',
    listingType: '',
    nursing: {
      slotType: '',
      noOfPax: '',
      wagePerHour: '',
      practicingScope: '',
      selectedDates: '',
      date: { from: '', to: '' },
      duration: { from: '', to: '' },
      isMultipleDate: '',
    },
    breaks: [
      {
        break_start: '',
        break_finish: '',
      },
    ],
  });

  useEffect(() => {
    if (id) {
      setCreateSlot((prevSlot) => ({
        ...prevSlot,
        clinicId: id,
      }));
    }
  }, [id]);

  function createNewSlot() {
    const formData = {
      clinicId: createSlot?.clinicId,
      shared_to: { 0: createSlot.shared_to },
      sharedTo: { 0: createSlot.shared_to },
      profession: 'nurse',
      price: createSlot.price,
      scope: createSlot.scope,
      job_description: createSlot.job_desc,
      listing_type: 'direct_listing',
      nursing: {
        slotType: 'NO_REPEAT',
        noOfPax: 1,
        wagePerHour: createSlot.price,
        practicingScope: createSlot.nursing?.practicingScope,
        selectedDates: {
          0: dayjs(createSlot.nursing.duration?.from).format('YYYY-MM-DD'),
        },
        date: {
          from: dayjs(createSlot.nursing.duration.from).format('YYYY-MM-DD'),
          to: dayjs(createSlot.nursing.duration.to).format('YYYY-MM-DD'),
        },

        duration: {
          from: createSlot.nursing.duration.from,
          to: createSlot.nursing.duration.to,
        },
        isMultipleDate: false,
      },
    };

    createSlot.breaks.forEach((b, idx) => {
      formData[`break[${idx}][break_start]`] = b.break_start;
      formData[`break[${idx}][break_finish]`] = b.break_finish;
    });

    axios
      .post(`${url}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Slot created successfully:', response.data);
        setCreateSlot({ ...createSlot });
        setOpen(true);
      })
      .catch((error) => {
        console.log('Error', error.message);
        toast.error(`Error: ${error.response.data.message}`, {
          autoClose: 2000,
          position: 'top-center',
        });
      });
    // console.log(formData);
  }

  // const handleOpenModal = () => {
  //   setOpen(false);
  // };

  const handleCloseModal = () => {
    setOpen(false);
    navigate(state?.prevLocation || -1);
  };

  const handleStartTimeChange = (newDate) => {
    if (newDate && newDate.isValid()) {
      setCreateSlot((prevSlot) => ({
        ...prevSlot,
        nursing: {
          ...prevSlot?.nursing,
          duration: {
            ...prevSlot?.nursing?.duration,
            from: newDate.format('YYYY-MM-DDTHH:mm'),
          },
        },
      }));
    }
  };

  const handleEndTimeChange = (newDate) => {
    if (newDate && newDate.isValid()) {
      setCreateSlot((prevSlot) => ({
        ...prevSlot,
        nursing: {
          ...prevSlot?.nursing,
          duration: {
            ...prevSlot?.nursing?.duration,
            to: newDate.format('YYYY-MM-DDTHH:mm'),
          },
        },
      }));
    }
  };

  const handleStartBreakChange = (newDate, index) => {
    if (newDate && newDate.isValid()) {
      setCreateSlot((prevSlot) => ({
        ...prevSlot,
        breaks: prevSlot.breaks.map((b, idx) =>
          idx === index
            ? {
                ...b,
                break_start: newDate.format('YYYY-MM-DDTHH:mm'),
              }
            : b,
        ),
      }));
    }
  };

  const handleEndBreakChange = (newDate, index) => {
    if (newDate && newDate.isValid()) {
      setCreateSlot((prevSlot) => ({
        ...prevSlot,
        breaks: prevSlot.breaks.map((b, idx) =>
          idx === index
            ? {
                ...b,
                break_finish: newDate.format('YYYY-MM-DDTHH:mm'),
              }
            : b,
        ),
      }));
    }
  };

  return (
    <Box sx={{ width: '100%', fontFamily: 'Poppins' }}>
      <Button
        sx={{
          textTransform: 'none',
          paddingLeft: 0,
        }}
        className='py-6 px-6 font-bold text-purple-500'
        variant='text'
        // eslint-disable-next-line react/jsx-no-bind
        onClick={handleBack}
      >
        Back
      </Button>
      <Box
        sx={{
          width: '100%',
          fontFamily: 'Poppins',
          display: 'flex',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Card
          sx={{
            width: '50%',
            borderRadius: 3,
            boxShadow: 3,
            backgroundColor: 'white',
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              py: 3,
              px: 4,
              borderBottom: '1px solid #eee',
              background: 'linear-gradient(90deg, #06b6d4 0%, #0891b2 100%)',
              color: 'white',
              fontWeight: 'bold',
              fontSize: 18,
              letterSpacing: 0.5,
            }}
          >
            Slot Information
          </Box>

          {/* Body */}
          <Box sx={{ px: 4, py: 4 }}>
            {/* Profession & Share To */}
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography fontWeight={600} color='gray.700'>
                  Profession*
                </Typography>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <Select
                    placeholder='Select'
                    style={{ height: '55px', fontSize: 14 }}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (value) {
                        setCreateSlot((prevSlot) => ({
                          ...prevSlot,
                          nursing: {
                            ...prevSlot?.nursing,
                            practicingScope: value,
                          },
                        }));
                      }
                    }}
                    value={createSlot?.nursing?.practicingScope || ''}
                    className='rounded-md text-gray-600'
                    displayEmpty
                  >
                    <MenuItem disabled value=''>
                      <em style={{ color: '#8C8C8C' }}>Select</em>
                    </MenuItem>
                    <MenuItem value='NURSE_EN'>EN</MenuItem>
                    <MenuItem value='NURSE_SN'>SN</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography fontWeight={600} color='gray.700'>
                  Share to*
                </Typography>
                <TextField
                  placeholder='Enter Locum ID'
                  fullWidth
                  sx={{ mt: 1 }}
                  value={createSlot?.shared_to || ''}
                  onChange={(e) =>
                    setCreateSlot({ ...createSlot, shared_to: e.target.value })
                  }
                />
              </Grid>
            </Grid>

            {/* Working Hours */}
            <Box mt={2}>
              <Typography fontWeight={600} color='gray.700'>
                Working Hours*
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box display='flex' justifyContent='space-between' mt={3}>
                  <DateTimePicker
                    label='Time Start'
                    sx={{ width: '48%' }}
                    format='DD MMM YYYY - hh:mm A'
                    value={
                      createSlot?.time_start
                        ? dayjs(createSlot?.time_start, 'YYYY-MM-DDTHH:mm')
                        : null
                    }
                    onChange={handleStartTimeChange}
                  />
                  <DateTimePicker
                    label='Time End'
                    sx={{ width: '48%' }}
                    format='DD MMM YYYY - hh:mm A'
                    value={
                      createSlot?.time_end
                        ? dayjs(createSlot?.time_end, 'YYYY-MM-DDTHH:mm')
                        : null
                    }
                    onChange={handleEndTimeChange}
                  />
                </Box>
              </LocalizationProvider>
            </Box>

            {/* Break Time */}
            <Box mt={2}>
              <Typography fontWeight={600} color='gray.700'>
                Break Time (optional)
              </Typography>
              {createSlot.breaks.map((b, index) => (
                <Box
                  key={index}
                  display='flex'
                  justifyContent='space-between'
                  mt={3}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label='Start'
                      sx={{ width: '48%' }}
                      format='DD MMM YYYY - hh:mm A'
                      value={
                        b.break_start
                          ? dayjs(b.break_start, 'YYYY-MM-DDTHH:mm')
                          : null
                      }
                      onChange={(d) => handleStartBreakChange(d, index)}
                    />
                    <DateTimePicker
                      label='End'
                      sx={{ width: '48%' }}
                      format='DD MMM YYYY - hh:mm A'
                      value={
                        b.break_finish
                          ? dayjs(b.break_finish, 'YYYY-MM-DDTHH:mm')
                          : null
                      }
                      onChange={(d) => handleEndBreakChange(d, index)}
                    />
                  </LocalizationProvider>
                </Box>
              ))}
              <Box display='flex' justifyContent='flex-end' mt={2}>
                <IconButton
                  color='primary'
                  onClick={() =>
                    setCreateSlot((prev) => ({
                      ...prev,
                      breaks: [
                        ...prev.breaks,
                        { break_start: '', break_finish: '' },
                      ],
                    }))
                  }
                >
                  <Icon
                    icon='material-symbols:add-circle-outline-rounded'
                    color='#06b6d4'
                    width={28}
                  />
                </IconButton>
              </Box>
            </Box>

            {/* Hourly Rate */}
            <Box>
              <Typography fontWeight={600} color='gray.700'>
                Hourly Rate*
              </Typography>
              <Box display='flex' alignItems='center' mt={1}>
                <TextField
                  id='price'
                  placeholder='Enter price (only number)'
                  sx={{ width: '50%' }}
                  value={createSlot?.price || ''}
                  onChange={(e) =>
                    setCreateSlot({ ...createSlot, price: e.target.value })
                  }
                />
                <Typography sx={{ ml: 2, color: 'gray.600', fontWeight: 500 }}>
                  SGD
                </Typography>
              </Box>
            </Box>

            {/* Scope */}
            <Box mt={2}>
              <Typography fontWeight={600} color='gray.700'>
                Scope*
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <Select
                  multiple
                  value={createSlot?.scope || []}
                  onChange={(e) => {
                    const { value } = e.target;
                    setCreateSlot({
                      ...createSlot,
                      scope:
                        typeof value === 'string' ? value.split(',') : value,
                    });
                  }}
                  renderValue={(selected) =>
                    selected.length ? (
                      selected.join(', ')
                    ) : (
                      <em style={{ color: '#8C8C8C' }}>Select</em>
                    )
                  }
                  displayEmpty
                  sx={{ borderRadius: 2 }}
                >
                  {[
                    'GP',
                    'Aesthetics',
                    'CHAS',
                    'PHPC',
                    'Covid Vaccines',
                    'DWD',
                    '2nd Doctor',
                    'Low Load',
                    'Moderate Load',
                    'Heavy Load',
                    'Specialist Clinic',
                  ].map((scope) => (
                    <MenuItem key={scope} value={scope}>
                      {scope}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* Job Description */}
            <Box mt={2}>
              <Typography fontWeight={600} color='gray.700'>
                Job Description (optional)
              </Typography>
              <TextField
                placeholder='Enter description'
                multiline
                rows={3}
                fullWidth
                sx={{ mt: 1 }}
                value={createSlot?.job_desc || ''}
                onChange={(e) =>
                  setCreateSlot({ ...createSlot, job_desc: e.target.value })
                }
              />
            </Box>

            {/* Submit Button */}
            <Box display='flex' justifyContent='center' mt={5}>
              <Button
                variant='contained'
                sx={{
                  textTransform: 'none',
                  px: 6,
                  py: 1.5,
                  fontWeight: 600,
                  backgroundColor: '#1788b9',
                  borderRadius: 2,
                  '&:hover': { backgroundColor: '#106b91' },
                }}
                // eslint-disable-next-line react/jsx-no-bind
                onClick={createNewSlot}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Card>
      </Box>
      <Dialog open={open} onClose={handleCloseModal}>
        <DialogTitle>Save Successful</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The past slot has been created successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
